import { base } from '$app/paths';

export interface AppSettings {
	selentorApiVersion: number;
	minRequiredVersion: number;
	currentVersion: number;
}

let settings: AppSettings | null = null;

/** Fetch runtime appsettings.json. Must complete before any API call. */
export async function loadAppSettings(): Promise<void> {
	const res = await fetch(`${base}/appsettings.json`, { cache: 'no-store' });
	if (!res.ok) {
		throw new Error(`Failed to load appsettings.json: ${res.status}`);
	}
	settings = (await res.json()) as AppSettings;
}

/** Read loaded settings. Throws if called before loadAppSettings() resolves. */
export function getAppSettings(): AppSettings {
	if (!settings) {
		throw new Error('appsettings.json not loaded — call loadAppSettings() first');
	}
	return settings;
}
